import React from 'react';
import styled from 'styled-components';
import Button from 'gatsby-theme-core/src/components/button/index';
import useSearch from 'gatsby-theme-vehicles/src/components/search/hooks/use-search';

const BoksResultsButton = styled((props) => {
  const { to, totalNumberOfVehicles, searching } = useSearch();
  return (
    <Button to={to} {...props}>
      {searching && (
        <>Zoek in {totalNumberOfVehicles ?? '...'} {totalNumberOfVehicles === 1 ? 'resultaat' : 'resultaten'}</>
      )}
      {!searching && (
        <>Zoeken</>
      )}
    </Button>
  );
})``;

export default BoksResultsButton;
